export default __webpack_public_path__ + "static/media/gpl_frontside.a2db39e7.png";